import React from 'react';
import { PetInterface } from 'types/pet';
import Introduction from './Introduction';
import NavItems from './NavItems';
import './content.scss';

import SectionsLayoutWithTranslation from './SectionsLayout';

const Content = ({ petProfile }: { petProfile?: PetInterface }) => (
  <section className="starter-guide-content">
    <Introduction />
    <NavItems />
    <SectionsLayoutWithTranslation petProfile={petProfile} />
  </section>
);
export default Content;
